import { render, staticRenderFns } from "./PosResult.vue?vue&type=template&id=77523b93&scoped=true"
import script from "./PosResult.vue?vue&type=script&lang=ts"
export * from "./PosResult.vue?vue&type=script&lang=ts"
import style0 from "./PosResult.vue?vue&type=style&index=0&id=77523b93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77523b93",
  null
  
)

export default component.exports